export default function useZoomPrevention() {
  let originalContent = null;

  const disableZoom = () => {
    const viewport = document.querySelector('meta[name=viewport]');
    if (viewport) {
      originalContent = viewport.getAttribute('content');
      viewport.setAttribute(
        'content',
        'width=device-width,height=device-height,initial-scale=1,maximum-scale=1,user-scalable=no,shrink-to-fit=no,viewport-fit=cover',
      );
    }
  };

  const enableZoom = () => {
    const viewport = document.querySelector('meta[name=viewport]');
    if (viewport && originalContent) {
      viewport.setAttribute('content', originalContent);
    }
  };

  const setupZoomPrevention = (element) => {
    const inputs = element.querySelectorAll('input, textarea, select');

    inputs.forEach((input) => {
      input.addEventListener('focus', disableZoom);
      input.addEventListener('blur', enableZoom);
    });
  };

  const cleanupZoomPrevention = (element) => {
    const inputs = element.querySelectorAll('input, textarea, select');

    inputs.forEach((input) => {
      input.removeEventListener('focus', disableZoom);
      input.removeEventListener('blur', enableZoom);
    });
  };

  return {
    setupZoomPrevention,
    cleanupZoomPrevention,
    disableZoom,
    enableZoom,
  };
}
